export default "__VITE_ASSET__B0nxq_XX__"